import { PRACTICE_MODES } from './modes';

const algorithms = {
  OLL: {
    id: 'OLL',
    name: 'Orientation of Last Layer',
    cases: {
      'OLL-1': {
        id: 'OLL-1',
        name: 'OLL 1 - Dot Case',
        algorithm: "F R' F' R U2' F R' F' R2' U2' R'",
        setupAlgorithm: "F R' F' R U2' F R' F' R2' U2' R'",
        imageUrl: '/images/oll/OLL-1.png',
        type: 'Dot Case'
      },
      'OLL-2': {
        id: 'OLL-2',
        name: 'OLL 2 - Dot Case',
        algorithm: "f U R U' R' f' F U R U' R' F'",
        setupAlgorithm: "f U R U' R' f' F U R U' R' F'",
        imageUrl: '/images/oll/OLL-2.png',
        type: 'Dot Case'
      },
      'OLL-3': {
        id: 'OLL-3',
        name: 'OLL 3 - Dot Case',
        algorithm: "F U R U' R' F' U f U R U' R' f' y",
        setupAlgorithm: "F U R U' R' F' U f U R U' R' f'",
        imageUrl: '/images/oll/OLL-3.png',
        type: 'Dot Case'
      },
      'OLL-4': {
        id: 'OLL-4',
        name: 'OLL 4 - Dot Case',
        algorithm: "F U R U' R' F' U' f U R U' R' f' y",
        setupAlgorithm: "F U R U' R' F' U' f U R U' R' f'",
        imageUrl: '/images/oll/OLL-4.png',
        type: 'Dot Case'
      },
      'OLL-5': {
        id: 'OLL-5',
        name: 'OLL 5 - Square Shape',
        algorithm: "r' U' R U' R' U2' r",
        setupAlgorithm: "r' U' R U' R' U2' r",
        imageUrl: '/images/oll/OLL-5.png',
        type: 'Square Shapes'
      },
      'OLL-6': {
        id: 'OLL-6',
        name: 'OLL 6 - Square Shape',
        algorithm: "r U R' U R U2' r'",
        setupAlgorithm: "r U R' U R U2' r'",
        imageUrl: '/images/oll/OLL-6.png',
        type: 'Square Shapes'
      },
      'OLL-7': {
        id: 'OLL-7',
        name: 'OLL 7 - Lightning Shape',
        algorithm: "r U2' R' U' R U' r'",
        setupAlgorithm: "r U2' R' U' R U' r'",
        imageUrl: '/images/oll/OLL-7.png',
        type: 'Lightning Shapes'
      },
      'OLL-8': {
        id: 'OLL-8',
        name: 'OLL 8 - Lightning Shape',
        algorithm: "r' U2' R U R' U r",
        setupAlgorithm: "r' U2' R U R' U r",
        imageUrl: '/images/oll/OLL-8.png',
        type: 'Lightning Shapes'
      },
      'OLL-9': {
        id: 'OLL-9',
        name: 'OLL 9 - Fish Shape',
        algorithm: "F U R U' R2' F' R U R U' R'",
        setupAlgorithm: "F U R U' R2' F' R U R U' R'",
        imageUrl: '/images/oll/OLL-9.png',
        type: 'Fish Shapes'
      },
      'OLL-10': {
        id: 'OLL-10',
        name: 'OLL 10 - Fish Shape',
        algorithm: "R U2' R' F R' F' R U' R U' R'",
        setupAlgorithm: "R U2' R' F R' F' R U' R U' R'",
        imageUrl: '/images/oll/OLL-10.png',
        type: 'Fish Shapes'
      },
      'OLL-11': {
        id: 'OLL-11',
        name: 'OLL 11 - Lightning Shape',
        algorithm: "M U' R U2' R' U' R U' R2' r",
        setupAlgorithm: "M U' R U2' R' U' R U' R2' r",
        imageUrl: '/images/oll/OLL-11.png',
        type: 'Lightning Shapes'
      },
      'OLL-12': {
        id: 'OLL-12',
        name: 'OLL 12 - Lightning Shape',
        algorithm: "F U R U' R' F' U' F U R U' R' F'",
        setupAlgorithm: "F U R U' R' F' U' F U R U' R' F'",
        imageUrl: '/images/oll/OLL-12.png',
        type: 'Lightning Shapes'
      },
      'OLL-13': {
        id: 'OLL-13',
        name: 'OLL 13 - Knight Move Shape',
        algorithm: "F' U' F r U' r' U r U r'",
        setupAlgorithm: "F' U' F r U' r' U r U r'",
        imageUrl: '/images/oll/OLL-13.png',
        type: 'Knight Move Shapes'
      },
      'OLL-14': {
        id: 'OLL-14',
        name: 'OLL 14 - Knight Move Shape',
        algorithm: "F U F' R' F R U' R' F' R",
        setupAlgorithm: "F U F' R' F R U' R' F' R",
        imageUrl: '/images/oll/OLL-14.png',
        type: 'Knight Move Shapes'
      },
      'OLL-15': {
        id: 'OLL-15',
        name: 'OLL 15 - Knight Move Shape',
        algorithm: "r' U' r U' R' U R r' U r",
        setupAlgorithm: "r' U' r U' R' U R r' U r",
        imageUrl: '/images/oll/OLL-15.png',
        type: 'Knight Move Shapes'
      },
      'OLL-16': {
        id: 'OLL-16',
        name: 'OLL 16 - Knight Move Shape',
        algorithm: "r U r' U R U' R' r U' r'",
        setupAlgorithm: "r U r' U R U' R' r U' r'",
        imageUrl: '/images/oll/OLL-16.png',
        type: 'Knight Move Shapes'
      },
      'OLL-17': {
        id: 'OLL-17',
        name: 'OLL 17 - Dot Case',
        algorithm: "F R' F' R U2' F R' F' R U' R U' R'",
        setupAlgorithm: "F R' F' R U2' F R' F' R U' R U' R'",
        imageUrl: '/images/oll/OLL-17.png',
        type: 'Dot Case'
      },
      'OLL-18': {
        id: 'OLL-18',
        name: 'OLL 18 - Dot Case',
        algorithm: "r' U2' R U R' U r2' U2' R' U' R U' r'",
        setupAlgorithm: "r' U2' R U R' U r2' U2' R' U' R U' r'",
        imageUrl: '/images/oll/OLL-18.png',
        type: 'Dot Case'
      },
      'OLL-19': {
        id: 'OLL-19',
        name: 'OLL 19 - Dot Case',
        algorithm: "F R' F' R M U R U' R' U' M'",
        setupAlgorithm: "F R' F' R M U R U' R' U' M'",
        imageUrl: '/images/oll/OLL-19.png',
        type: 'Dot Case'
      },
      'OLL-20': {
        id: 'OLL-20',
        name: 'OLL 20 - Dot Case',
        algorithm: "r U R' U' M2' U R U' R' U' M'",
        setupAlgorithm: "r U R' U' M2' U R U' R' U' M'",
        imageUrl: '/images/oll/OLL-20.png',
        type: 'Dot Case'
      },
      'OLL-21': {
        id: 'OLL-21',
        name: 'OLL 21 - OCLL',
        algorithm: "R U R' U R U' R' U R U2' R'",
        setupAlgorithm: "R U R' U R U' R' U R U2' R'",
        imageUrl: '/images/oll/OLL-21.png',
        type: 'OCLL'
      },
      'OLL-22': {
        id: 'OLL-22',
        name: 'OLL 22 - OCLL',
        algorithm: "R' U2' R2' U R2' U R2' U2' R'",
        setupAlgorithm: "R' U2' R2' U R2' U R2' U2' R'",
        imageUrl: '/images/oll/OLL-22.png',
        type: 'OCLL'
      },
      'OLL-23': {
        id: 'OLL-23',
        name: 'OLL 23 - OCLL',
        algorithm: "R U2' R D R' U2' R D' R2'",
        setupAlgorithm: "R U2' R D R' U2' R D' R2'",
        imageUrl: '/images/oll/OLL-23.png',
        type: 'OCLL'
      },
      'OLL-24': {
        id: 'OLL-24',
        name: 'OLL 24 - OCLL',
        algorithm: "F R' F' r U R U' r'",
        setupAlgorithm: "F R' F' r U R U' r'",
        imageUrl: '/images/oll/OLL-24.png',
        type: 'OCLL'
      },
      'OLL-25': {
        id: 'OLL-25',
        name: 'OLL 25 - OCLL',
        algorithm: "R' F' r U R U' r' F",
        setupAlgorithm: "R' F' r U R U' r' F",
        imageUrl: '/images/oll/OLL-25.png',
        type: 'OCLL'
      },
      'OLL-26': {
        id: 'OLL-26',
        name: 'OLL 26 - OCLL',
        algorithm: "R U R' U R U2' R'",
        setupAlgorithm: "R U R' U R U2' R'",
        imageUrl: '/images/oll/OLL-26.png',
        type: 'OCLL'
      },
      'OLL-27': {
        id: 'OLL-27',
        name: 'OLL 27 - OCLL',
        algorithm: "R U2' R' U' R U' R'",
        setupAlgorithm: "R U2' R' U' R U' R'",
        imageUrl: '/images/oll/OLL-27.png',
        type: 'OCLL'
      },
      'OLL-28': {
        id: 'OLL-28',
        name: 'OLL 28 - All Corners Oriented',
        algorithm: "R U R' U' M' U R U' r'",
        setupAlgorithm: "R U R' U' M' U R U' r'",
        imageUrl: '/images/oll/OLL-28.png',
        type: 'All Corners Oriented'
      },
      'OLL-29': {
        id: 'OLL-29',
        name: 'OLL 29 - Awkward Shape',
        algorithm: "M F R' F' R U R U' R' U' M'",
        setupAlgorithm: "M F R' F' R U R U' R' U' M'",
        imageUrl: '/images/oll/OLL-29.png',
        type: 'Awkward Shapes'
      },
      'OLL-30': {
        id: 'OLL-30',
        name: 'OLL 30 - Awkward Shape',
        algorithm: "F U R U2' R' U R U2' R' U' F'",
        setupAlgorithm: "F U R U2' R' U R U2' R' U' F'",
        imageUrl: '/images/oll/OLL-30.png',
        type: 'Awkward Shapes'
      },
      'OLL-31': {
        id: 'OLL-31',
        name: 'OLL 31 - P Shape',
        algorithm: "R' F R U R' U' F' U R",
        setupAlgorithm: "R' F R U R' U' F' U R",
        imageUrl: '/images/oll/OLL-31.png',
        type: 'P Shapes'
      },
      'OLL-32': {
        id: 'OLL-32',
        name: 'OLL 32 - P Shape',
        algorithm: "f R' F' R U R U' R' S'",
        setupAlgorithm: "f R' F' R U R U' R' S'",
        imageUrl: '/images/oll/OLL-32.png',
        type: 'P Shapes'
      },
      'OLL-33': {
        id: 'OLL-33',
        name: 'OLL 33 - T Shape',
        algorithm: "F R' F' R U R U' R'",
        setupAlgorithm: "F R' F' R U R U' R'",
        imageUrl: '/images/oll/OLL-33.png',
        type: 'T Shapes'
      },
      'OLL-34': {
        id: 'OLL-34',
        name: 'OLL 34 - C Shape',
        algorithm: "F U R' U' R' F' R U R2' U' R'",
        setupAlgorithm: "F U R' U' R' F' R U R2' U' R'",
        imageUrl: '/images/oll/OLL-34.png',
        type: 'C Shapes'
      },
      'OLL-35': {
        id: 'OLL-35',
        name: 'OLL 35 - Fish Shape',
        algorithm: "R U2' R' F R' F' R2' U2' R'",
        setupAlgorithm: "R U2' R' F R' F' R2' U2' R'",
        imageUrl: '/images/oll/OLL-35.png',
        type: 'Fish Shapes'
      },
      'OLL-36': {
        id: 'OLL-36',
        name: 'OLL 36 - W Shape',
        algorithm: "F' L F L' U' L' U' L U L' U L y2'",
        setupAlgorithm: "F' L F L' U' L' U' L U L' U L",
        imageUrl: '/images/oll/OLL-36.png',
        type: 'W Shapes'
      },
      'OLL-37': {
        id: 'OLL-37',
        name: 'OLL 37 - Fish Shape',
        algorithm: "F R U' R' U R U R' F'",
        setupAlgorithm: "F R U' R' U R U R' F'",
        imageUrl: '/images/oll/OLL-37.png',
        type: 'Fish Shapes'
      },
      'OLL-38': {
        id: 'OLL-38',
        name: 'OLL 38 - W Shape',
        algorithm: "F R' F' R U R U R' U' R U' R'",
        setupAlgorithm: "F R' F' R U R U R' U' R U' R'",
        imageUrl: '/images/oll/OLL-38.png',
        type: 'W Shapes'
      },
      'OLL-39': {
        id: 'OLL-39',
        name: 'OLL 39 - Lightning Shape',
        algorithm: "L U F' U' L' U L F L' y'",
        setupAlgorithm: "L U F' U' L' U L F L'",
        imageUrl: '/images/oll/OLL-39.png',
        type: 'Lightning Shapes'
      },
      'OLL-40': {
        id: 'OLL-40',
        name: 'OLL 40 - Lightning Shape',
        algorithm: "R' U' F U R U' R' F' R y'",
        setupAlgorithm: "R' U' F U R U' R' F' R",
        imageUrl: '/images/oll/OLL-40.png',
        type: 'Lightning Shapes'
      },
      'OLL-41': {
        id: 'OLL-41',
        name: 'OLL 41 - Awkward Shape',
        algorithm: "F U R U' R' F' R U2' R' U' R U' R' y2'",
        setupAlgorithm: "F U R U' R' F' R U2' R' U' R U' R'",
        imageUrl: '/images/oll/OLL-41.png',
        type: 'Awkward Shapes'
      },
      'OLL-42': {
        id: 'OLL-42',
        name: 'OLL 42 - Awkward Shape',
        algorithm: "F U R U' R' F' R' U2' R U R' U R",
        setupAlgorithm: "F U R U' R' F' R' U2' R U R' U R",
        imageUrl: '/images/oll/OLL-42.png',
        type: 'Awkward Shapes'
      },
      'OLL-43': {
        id: 'OLL-43',
        name: 'OLL 43 - P Shape',
        algorithm: "f' U' L' U L f",
        setupAlgorithm: "f' U' L' U L f",
        imageUrl: '/images/oll/OLL-43.png',
        type: 'P Shapes'
      },
      'OLL-44': {
        id: 'OLL-44',
        name: 'OLL 44 - P Shape',
        algorithm: "f U R U' R' f'",
        setupAlgorithm: "f U R U' R' f'",
        imageUrl: '/images/oll/OLL-44.png',
        type: 'P Shapes'
      },
      'OLL-45': {
        id: 'OLL-45',
        name: 'OLL 45 - T Shape',
        algorithm: "F U R U' R' F'",
        setupAlgorithm: "F U R U' R' F'",
        imageUrl: '/images/oll/OLL-45.png',
        type: 'T Shapes'
      },
      'OLL-46': {
        id: 'OLL-46',
        name: 'OLL 46 - C Shape',
        algorithm: "R' U' F R' F' R U R",
        setupAlgorithm: "R' U' F R' F' R U R",
        imageUrl: '/images/oll/OLL-46.png',
        type: 'C Shapes'
      },
      'OLL-47': {
        id: 'OLL-47',
        name: 'OLL 47 - L Shape',
        algorithm: "F' U' L' U L U' L' U L F",
        setupAlgorithm: "F' U' L' U L U' L' U L F",
        imageUrl: '/images/oll/OLL-47.png',
        type: 'L Shapes'
      },
      'OLL-48': {
        id: 'OLL-48',
        name: 'OLL 48 - L Shape',
        algorithm: "F U R U' R' U R U' R' F'",
        setupAlgorithm: "F U R U' R' U R U' R' F'",
        imageUrl: '/images/oll/OLL-48.png',
        type: 'L Shapes'
      },
      'OLL-49': {
        id: 'OLL-49',
        name: 'OLL 49 - L Shape',
        algorithm: "r' U r2' U' r2' U' r2' U r' y2'",
        setupAlgorithm: "r' U r2' U' r2' U' r2' U r'",
        imageUrl: '/images/oll/OLL-49.png',
        type: 'L Shapes'
      },
      'OLL-50': {
        id: 'OLL-50',
        name: 'OLL 50 - L Shape',
        algorithm: "r U' r2' U r2' U r2' U' r",
        setupAlgorithm: "r U' r2' U r2' U r2' U' r",
        imageUrl: '/images/oll/OLL-50.png',
        type: 'L Shapes'
      },
      'OLL-51': {
        id: 'OLL-51',
        name: 'OLL 51 - Line Shape',
        algorithm: "f U R U' R' U R U' R' f'",
        setupAlgorithm: "f U R U' R' U R U' R' f'",
        imageUrl: '/images/oll/OLL-51.png',
        type: 'Line Shapes'
      },
      'OLL-52': {
        id: 'OLL-52',
        name: 'OLL 52 - Line Shape',
        algorithm: "F R U R' d R' U' R U' R'",
        setupAlgorithm: "F R U R' d R' U' R U' R'",
        imageUrl: '/images/oll/OLL-52.png',
        type: 'Line Shapes'
      },
      'OLL-53': {
        id: 'OLL-53',
        name: 'OLL 53 - L Shape',
        algorithm: "r' U2' R U R' U' R U R' U r",
        setupAlgorithm: "r' U2' R U R' U' R U R' U r",
        imageUrl: '/images/oll/OLL-53.png',
        type: 'L Shapes'
      },
      'OLL-54': {
        id: 'OLL-54',
        name: 'OLL 54 - L Shape',
        algorithm: "r U2' R' U' R U R' U' R U' r'",
        setupAlgorithm: "r U2' R' U' R U R' U' R U' r'",
        imageUrl: '/images/oll/OLL-54.png',
        type: 'L Shapes'
      },
      'OLL-55': {
        id: 'OLL-55',
        name: 'OLL 55 - Line Shape',
        algorithm: "F R' F' U2' R U R' U R2' U2' R'",
        setupAlgorithm: "F R' F' U2' R U R' U R2' U2' R'",
        imageUrl: '/images/oll/OLL-55.png',
        type: 'Line Shapes'
      },
      'OLL-56': {
        id: 'OLL-56',
        name: 'OLL 56 - Line Shape',
        algorithm: "r U r' R U R' U' R U R' U' r U' r'",
        setupAlgorithm: "r U r' R U R' U' R U R' U' r U' r'",
        imageUrl: '/images/oll/OLL-56.png',
        type: 'Line Shapes'
      },
      'OLL-57': {
        id: 'OLL-57',
        name: 'OLL 57 - All Corners Oriented',
        algorithm: "r U R' U' M U R U' R'",
        setupAlgorithm: "r U R' U' M U R U' R'",
        imageUrl: '/images/oll/OLL-57.png',
        type: 'All Corners Oriented'
      }
    }
  },
  PLL: {
    id: 'PLL',
    name: 'Permutation of Last Layer',
    cases: {
      'Aa': {
        id: 'Aa',
        name: 'Aa Permutation',
        algorithm: "x R2' D2' R U R' D2' R U' R x'",
        setupAlgorithm: "x R2' D2' R U R' D2' R U' R x'",
        imageUrl: '/images/pll/Aa.png',
        type: 'Adjacent Swap'
      },
      'Ab': {
        id: 'Ab',
        name: 'Ab Permutation',
        algorithm: "x R' U R' D2' R U' R' D2' R2' x'",
        setupAlgorithm: "x R' U R' D2' R U' R' D2' R2' x'",
        imageUrl: '/images/pll/Ab.png',
        type: 'Adjacent Swap'
      },
      'E': {
        id: 'E',
        name: 'E Permutation',
        algorithm: "x' D R U R' D' R U' R' D R U' R' D' R U R' x y'",
        setupAlgorithm: "x' D R U R' D' R U' R' D R U' R' D' R U R' x",
        imageUrl: '/images/pll/E.png',
        type: 'Opposite Swap'
      },
      'F': {
        id: 'F',
        name: 'F Permutation',
        algorithm: "R' U' R U' R' U R U R2' F' R U R U' R' F U R y'",
        setupAlgorithm: "R' U' R U' R' U R U R2' F' R U R U' R' F U R",
        imageUrl: '/images/pll/F.png',
        type: 'Adjacent Swap'
      },
      'Ga': {
        id: 'Ga',
        name: 'Ga Permutation',
        algorithm: "R' U' R D' U R2' U R' U R U' R U' R2' D",
        setupAlgorithm: "R' U' R D' U R2' U R' U R U' R U' R2' D",
        imageUrl: '/images/pll/Ga.png',
        type: 'Adjacent Swap'
      },
      'Gb': {
        id: 'Gb',
        name: 'Gb Permutation',
        algorithm: "R2' U R' U R' U' R U' R2' D U' R' U R D'",
        setupAlgorithm: "R2' U R' U R' U' R U' R2' D U' R' U R D'",
        imageUrl: '/images/pll/Gb.png',
        type: 'Adjacent Swap'
      },
      'Gc': {
        id: 'Gc',
        name: 'Gc Permutation',
        algorithm: "D' R U R' U' D R2' U' R U' R' U R' U R2'",
        setupAlgorithm: "D' R U R' U' D R2' U' R U' R' U R' U R2'",
        imageUrl: '/images/pll/Gc.png',
        type: 'Adjacent Swap'
      },
      'Gd': {
        id: 'Gd',
        name: 'Gd Permutation',
        algorithm: "R2' U' R U' R U R' U R2' D' U R U' R' D",
        setupAlgorithm: "R2' U' R U' R U R' U R2' D' U R U' R' D",
        imageUrl: '/images/pll/Gd.png',
        type: 'Adjacent Swap'
      },
      'H': {
        id: 'H',
        name: 'H Permutation',
        algorithm: "M2' U' M2' U2' M2' U' M2'",
        setupAlgorithm: "M2' U' M2' U2' M2' U' M2'",
        imageUrl: '/images/pll/H.png',
        type: 'Edge Permutation'
      },
      'Ja': {
        id: 'Ja',
        name: 'Ja Permutation',
        algorithm: "L' R' U2' R U R' U2' L U' R",
        setupAlgorithm: "L' R' U2' R U R' U2' L U' R",
        imageUrl: '/images/pll/Ja.png',
        type: 'Adjacent Swap'
      },
      'Jb': {
        id: 'Jb',
        name: 'Jb Permutation',
        algorithm: "R U R2' F' R U R U' R' F R U' R'",
        setupAlgorithm: "R U R2' F' R U R U' R' F R U' R'",
        imageUrl: '/images/pll/Jb.png',
        type: 'Adjacent Swap'
      },
      'Na': {
        id: 'Na',
        name: 'Na Permutation',
        algorithm: "R U R' U2' R U R2' F' R U R U' R' F R U' R'",
        setupAlgorithm: "R U R' U2' R U R2' F' R U R U' R' F R U' R' U' R U' R'",
        imageUrl: '/images/pll/Na.png',
        type: 'Opposite Swap'
      },
      'Nb': {
        id: 'Nb',
        name: 'Nb Permutation',
        algorithm: "F r' F' r U r U' r2' D' F r U r' F' D r",
        setupAlgorithm: "F r' F' r U r U' r2' D' F r U r' F' D r",
        imageUrl: '/images/pll/Nb.png',
        type: 'Opposite Swap'
      },
      'Ra': {
        id: 'Ra',
        name: 'Ra Permutation',
        algorithm: "R U2' R D R' U R D' R' U' R' U R U R'",
        setupAlgorithm: "R U2' R D R' U R D' R' U' R' U R U R'",
        imageUrl: '/images/pll/Ra.png',
        type: 'Adjacent Swap'
      },
      'Rb': {
        id: 'Rb',
        name: 'Rb Permutation',
        algorithm: "R' U R U R' U' R' D' R U R' D R U2' R",
        setupAlgorithm: "R' U R U R' U' R' D' R U R' D R U2' R",
        imageUrl: '/images/pll/Rb.png',
        type: 'Adjacent Swap'
      },
      'T': {
        id: 'T',
        name: 'T Permutation',
        algorithm: "F R U' R' U R U R2' F' R U R U' R'",
        setupAlgorithm: "F R U' R' U R U R2' F' R U R U' R'",
        imageUrl: '/images/pll/T.png',
        type: 'Adjacent Swap'
      },
      'Ua': {
        id: 'Ua',
        name: 'Ua Permutation',
        algorithm: "M2' U' M' U2' M U' M2'",
        setupAlgorithm: "M2' U' M' U2' M U' M2'",
        imageUrl: '/images/pll/Ua.png',
        type: 'Edge Permutation'
      },
      'Ub': {
        id: 'Ub',
        name: 'Ub Permutation',
        algorithm: "M2' U M' U2' M U M2'",
        setupAlgorithm: "M2' U M' U2' M U M2'",
        imageUrl: '/images/pll/Ub.png',
        type: 'Edge Permutation'
      },
      'V': {
        id: 'V',
        name: 'V Permutation',
        algorithm: "D2' R' U R D' R2' U' R' U R' U R' D' R U2' R'",
        setupAlgorithm: "D2' R' U R D' R2' U' R' U R' U R' D' R U2' R'",
        imageUrl: '/images/pll/V.png',
        type: 'Opposite Swap'
      },
      'Y': {
        id: 'Y',
        name: 'Y Permutation',
        algorithm: "F R' F' R U R U' R' F R U' R' U R U R' F'",
        setupAlgorithm: "F R' F' R U R U' R' F R U' R' U R U R' F'",
        imageUrl: '/images/pll/Y.png',
        type: 'Opposite Swap'
      },
      'Z': {
        id: 'Z',
        name: 'Z Permutation',
        algorithm: "M U2' M2' U2' M U' M2' U' M2'",
        setupAlgorithm: "M U2' M2' U2' M U' M2' U' M2'",
        imageUrl: '/images/pll/Z.png',
        type: 'Edge Permutation'
      }
    }
  }
};

const getRandomUMove = () => {
  const uMoves = ['U', "U'", 'U2'];
  return uMoves[Math.floor(Math.random() * uMoves.length)];
};

const shouldAddUMove = () => Math.random() < 0.75;

const lastMoveIsUMove = (algorithm) => {
  const lastMove = algorithm.trim().split(' ').pop();
  return ['U', "U'", 'U2'].includes(lastMove);
};

const getRandomInsert = () => {
  const inserts = [
    { moves: "R U R'", name: "connected 3-move insert" },
    { moves: "R U' R'", name: "paired 3-move insert" },
    { moves: "R' F R F'", name: "hedge insert" },
    { moves: "F R' F' R", name: "sledge insert" }
  ];
  return inserts[Math.floor(Math.random() * inserts.length)];
};

export const getRandomCase = (setId, mode = PRACTICE_MODES.OLL.EXECUTION, selectedAlgorithms = null) => {
  const set = algorithms[setId];
  if (!set) return null;
  
  let cases = Object.values(set.cases);
  if (selectedAlgorithms && selectedAlgorithms.length > 0) {
    cases = cases.filter(c => selectedAlgorithms.includes(c.id));
  }
  
  if (cases.length === 0) return null;
  const selectedCase = { ...cases[Math.floor(Math.random() * cases.length)] };
  
  console.log('Initial setup:', selectedCase.setupAlgorithm);
  
  // Step 1: Add U move (75% chance) - This should happen for ALL modes
  if (shouldAddUMove() && !lastMoveIsUMove(selectedCase.setupAlgorithm)) {
    const uMove = getRandomUMove();
    selectedCase.setupAlgorithm = `${selectedCase.setupAlgorithm} ${uMove}`;
    console.log('After U move:', selectedCase.setupAlgorithm, '(added', uMove, ')');
  } else {
    console.log('No U move added:', shouldAddUMove() ? 'last move was U' : 'failed random check');
  }
  
  // Step 2: Add recognition moves for recognition modes
  const isRecognitionMode = mode.toUpperCase().includes('RECOGNITION');
                         
  if (isRecognitionMode) {
    const insert = getRandomInsert();
    selectedCase.setupAlgorithm = `${selectedCase.setupAlgorithm} ${insert.moves}`;
    selectedCase.displayName = insert.name;
    console.log('After insert:', selectedCase.setupAlgorithm, '(added', insert.moves, ')');
  } else {
    console.log('No insert added, mode:', mode);
  }
  
  return selectedCase;
};

export const getAlgorithmSet = (setId) => algorithms[setId];

export const getAlgorithm = (type, id) => {
  if (!type || !id) return null;
  return algorithms[type]?.cases[id] || null;
};

export { algorithms }; 